import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  loadError: {
    id: 'gsxeer',
    defaultMessage: 'Unable to load PDF preview. Please try again.',
    description: 'Error message when the HTML template PDF preview fails to load',
  },
  emptyContent: {
    id: '+gSNEB',
    defaultMessage: 'Start typing to see preview',
    description: 'Message shown when the HTML editor is empty',
  },
  validationError: {
    id: 'ole4RQ',
    defaultMessage: 'Fix validation errors to see preview',
    description: 'Message shown when there are validation errors in the HTML',
  },
});
